import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CookieTkService {
  private apiUrl = environment.apiURL+ "/api/login";
  private apiLogoutUrl = environment.apiURL + "/api/logout";

  constructor(private http: HttpClient) { }

  setCookie(token:string): Observable<any> {
    return this.http.post(this.apiUrl, { token }, { withCredentials: true });
  }

   logout(provider: string): Observable<any> {
    const pToken = sessionStorage.getItem('pToken');
    return this.http.post(this.apiLogoutUrl, { token: pToken, provider }, { withCredentials: true });
  }
}